module.exports = {
      id: "comment-usage",
      viewBox: "0 0 14 15",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#comment",
      toString: function () {
        return this.url;
      }
    }